const DEFAULT_COLORS = ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]

function shape(element) {
  const size = `${Math.round(10 * (Math.random() + 0.5))}px`
  element.style.width = size
  element.style.height = size
  return element
}

function createElements(container, count, colors) {
  return Array.from({ length: count }).map((_, index) => {
    const element = document.createElement("div")
    element.style.backgroundColor = colors[index % colors.length]
    element.style.position = "absolute"
    container.appendChild(shape(element))
    return element
  })
}

function randomPhysics(angle, spread, velocity, random) {
  const angleRad = angle * (Math.PI / 180)
  const spreadRad = spread * (Math.PI / 180)

  return {
    x: 0,
    y: 0,
    wobble: 10 * random(),
    velocity: 0.5 * velocity + random() * velocity,
    angle2D: -angleRad + (0.5 * spreadRad - random() * spreadRad),
    angle3D: -Math.PI / 4 + random() * (Math.PI / 2),
    tiltAngle: random() * Math.PI
  }
}

function updateFetti(fetti, progress, decay) {
  fetti.physics.x += Math.cos(fetti.physics.angle2D) * fetti.physics.velocity
  fetti.physics.y += Math.sin(fetti.physics.angle2D) * fetti.physics.velocity
  fetti.physics.z += Math.sin(fetti.physics.angle3D) * fetti.physics.velocity
  fetti.physics.wobble += 0.1
  fetti.physics.velocity *= decay
  fetti.physics.y += 3
  fetti.physics.tiltAngle += 0.1

  const { x, y, tiltAngle, wobble } = fetti.physics
  fetti.element.style.transform = `translate3d(${x + 10 * Math.cos(wobble)}px, ${y + 10 * Math.sin(wobble)}px, 0) rotate3d(1, 1, 1, ${tiltAngle}rad)`
  fetti.element.style.opacity = 1 - progress
}

function animate(container, fettis, decay) {
  const frames = 200
  let frame = 0

  const step = () => {
    const progress = frame / frames
    fettis.forEach((fetti) => updateFetti(fetti, progress, decay))
    frame += 1

    if (frame < frames) {
      requestAnimationFrame(step)
      return
    }

    fettis.forEach((fetti) => {
      if (fetti.element.parentNode === container) {
        container.removeChild(fetti.element)
      }
    })
  }

  requestAnimationFrame(step)
}

export function runConfetti(container, options = {}) {
  const {
    angle = 90,
    decay = 0.9,
    spread = 45,
    startVelocity = 45,
    elementCount = 50,
    colors = DEFAULT_COLORS,
    random = Math.random
  } = options

  const fettis = createElements(container, elementCount, colors).map((element) => ({
    element,
    physics: randomPhysics(angle, spread, startVelocity, random)
  }))

  animate(container, fettis, decay)
}
